var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.object.selected,
        expression: "object.selected",
      },
    ],
    attrs: { type: "checkbox" },
    domProps: {
      checked: Array.isArray(_vm.object.selected)
        ? _vm._i(_vm.object.selected, null) > -1
        : _vm.object.selected,
    },
    on: {
      change: function ($event) {
        var $$a = _vm.object.selected,
          $$el = $event.target,
          $$c = $$el.checked ? true : false
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v)
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.object, "selected", $$a.concat([$$v]))
          } else {
            $$i > -1 &&
              _vm.$set(
                _vm.object,
                "selected",
                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
              )
          }
        } else {
          _vm.$set(_vm.object, "selected", $$c)
        }
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }